import Services from './base-services'

const service = new Services('teachers-resources')

export default {
    getActivities() {
        return service.get('', undefined, true)
    },
}
